import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator'

import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import PeopleList from './PeopleList.vue'

declare global {
    namespace graph {
        export type PeopleRequest = {
            currentPage: number;
            pageSize: number;
            nextLink: string | null;
        }

        export type PeopleResponse = {
            currentPage: number;
            items: account.User[];
            nextLink: string;
        }
    }
}

@Component({
    components : {
        WebpartTemplate,
        PeopleList
    }
})
export default class MyPeoplesWebpart extends Mixins(WebpartBase) {    
    created() {        
        this.loading = true;        
    }     
    
    onListMounted() {
        this.loading = false;
    }
}